<template>
  <div
    v-if="$store.state.authentification.connectUserID !== meeting.owner_id"
    style="margin-right:10px;"
  >
    <b-tooltip position="is-left" v-bind:label="ownerMeeting">
      <span
        @mouseover="whoIsOwner(meeting.owner_id)"
      >
        <img
          src="@/assets/img/icons/persons-icon.png"
          class="icon"
          alt="icon-share"
        />
      </span>
    </b-tooltip>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'WhoIsOwner',
  props: {
    meeting: Object
  },
  data () {
    return {
      ownerMeeting: null
    }
  },
  methods: {
    whoIsOwner (id) {
      this.ownerMeeting = 'Loading...'
      axios.defaults.headers.common['Authorization'] =
        'Bearer ' + window.store.getters.userToken
      axios.get(process.env.URL_SSO_API + 'user/' + id).then(response => {
        this.ownerMeeting =
          'Propriétaire : ' +
          response.data.firstname +
          ' ' +
          response.data.lastname
      })
    }
  }
}
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/adminPage/components/WhoIsOwner.vue